/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import {
    Alert,
    ContentContainerBodyShift,
    DisplayHtmlContent,
    useFlags,
} from 'sarsaparilla';

type GovShutdownBannerProps = {
    className?: string;
};

function GovShutdownBanner({ className }: GovShutdownBannerProps) {
    const { iapShutdownBannerContent } = useFlags();

    if (!iapShutdownBannerContent?.enabled) {
        return null;
    }

    const { title, content, type = 'warning' } = iapShutdownBannerContent;

    let decodedBannerBody = '';
    try {
        decodedBannerBody = decodeURIComponent(content);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        decodedBannerBody = '';
    }

    return (
        <ContentContainerBodyShift className={className}>
            <Alert type={type} heading={title}>
                <DisplayHtmlContent html={decodedBannerBody} />
            </Alert>
        </ContentContainerBodyShift>
    );
}

export default GovShutdownBanner;
